export default {"src":"/_next/static/media/car-offer-strip.8e188bb7.svg","height":85,"width":122};